import { Typography } from 'antd';
import styled from 'styled-components';

import { ContentAuth } from '../../../styles/common/auth';

const { Paragraph } = Typography;

export const ParagraphStyled = styled(Paragraph)`
  font-size: 20px;
  text-align: center;
`;

export const ContentStyled = styled(ContentAuth)`
  h2,
  p {
    color: var(--gray-200);
    text-align: center;
  }

  svg {
    color: var(--gray-200);
  }

  h2 {
    font-size: 22px;
    margin: 10px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;

    > a {
      margin-right: 5px;
      display: inherit;
    }
  }

  p {
    margin-bottom: 20px;
    align-self: flex-start;
  }
`;
